(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name cycle.factory:AdminCycleFactory
     *
     * @description
     *
     */
    angular
        .module('cycle')
        .factory('AdminCycleFactory', AdminCycleFactory);

    function AdminCycleFactory() {

    	//----declare DTOs------
    	//search cycle object
    	function CycleSearchDTO(){
    		this.cycleList =[];
    		this.nextRecordsMonthFrom= null;
    		this.nextRecordsMonthTo= null;
    		this.nextRecordsBidDeadline= null;
    		this.nextRecordsCrewGroupCode= null;
    		this.nextRecordsCrewGroups = null;
        }

    	//grid view cycle object
    	function CycleDTO(){
    		this.cycleId = null;
    		this.version= null;
    		this.cycleName= null;
    		this.dateFrom= null;
    		this.dateTo= null;
    		this.fcBidDeadline= null;
    		this.ccBidDeadline= null;
    		this.insBidDeadline= null;
    		this.crewGroupCode= null;
    		this.isValid = true;
    	}

    	//newly added Cycle object
    	function CycleSaveRequestDTO(){
    		this.cycleName= null;
    		this.dateFrom= null;
    		this.dateTo= null;
    		this.fcBidDeadline= null;
    		this.ccBidDeadline= null;
    		this.insBidDeadline= null;
    		this.crewGroupCode= null;
    	}

    	//cycle delete request object
    	function CycleDeleteRequestDTO(){
    		this.cycleId = null;
    		this.version= null;
    	}

        //----Define Function --------
    	//getter and setters of Cycle Search DTO
    	function GetFormattedCycleSearchDTO(searchResponce){
    		var cycleSearchDTO = new CycleSearchDTO();
    		if(!!searchResponce.cycleList && searchResponce.cycleList.length>0){
    			for(var i=0;i<searchResponce.cycleList.length;i++){
    				var cycleDTO = new CycleDTO();
    				cycleDTO.cycleId = searchResponce.cycleList[i].cycleId;
    				cycleDTO.version = searchResponce.cycleList[i].version;
    				cycleDTO.cycleName = searchResponce.cycleList[i].cycleName;
    				cycleDTO.dateFrom = searchResponce.cycleList[i].dateFrom;
    				cycleDTO.fcBidDeadline = searchResponce.cycleList[i].fcBidDeadline;
    				cycleDTO.ccBidDeadline = searchResponce.cycleList[i].ccBidDeadline;
    				cycleDTO.insBidDeadline = searchResponce.cycleList[i].insBidDeadline;
    				cycleDTO.dateTo =searchResponce.cycleList[i].dateTo;
    				cycleDTO.crewGroupCode = searchResponce.cycleList[i].crewGroupCode;
    				cycleSearchDTO.cycleList.push(cycleDTO) ;
    			}
    		}
    		cycleSearchDTO.nextRecordsMonthFrom = searchResponce.nextRecordsMonthFrom;
    		cycleSearchDTO.nextRecordsMonthTo = searchResponce.nextRecordsMonthTo;
    		cycleSearchDTO.nextRecordsBidDeadline = searchResponce.nextRecordsBidDeadline;
    		cycleSearchDTO.nextRecordsCrewGroupCode = searchResponce.nextRecordsCrewGroupCode;
    		cycleSearchDTO.nextRecordsCrewGroups = searchResponce.crewGroups;
    		return cycleSearchDTO;
    	}

    	function GetCycleSearchDTO(){
    		return new CycleSearchDTO();
    	}

    	//getter and setter of Cycle DTO
    	function GetCycleDTO(){
    		return new CycleDTO();
    	}

    	//getter and setter of Cycle Save Request
    	function GetFormattedCycleSaveRequest(newCycle){
    		var cycleSaveReq = new CycleSaveRequestDTO();
    		cycleSaveReq.cycleName = newCycle.cycleName;
    		cycleSaveReq.dateFrom = newCycle.dateFrom;
    		cycleSaveReq.dateTo = newCycle.dateTo;
    		cycleSaveReq.fcBidDeadline = newCycle.bidDeadline;
    		cycleSaveReq.ccBidDeadline = newCycle.bidDeadline;
        cycleSaveReq.insBidDeadline = newCycle.bidDeadline;
    		cycleSaveReq.crewGroupCode = newCycle.crewGroupCode;
    		return cycleSaveReq;
    	}

    	function GetCycleSaveRequest(){
    		return new CycleSaveRequestDTO();
    	}

    	//getter and setter of Delete Request DTO
    	function GetCycleDeleteRequestDTO(){
    		return new CycleDeleteRequestDTO();
    	}

    	function GetFormattedCycleDeleteRequestDTO(cycleDTO){
    		var cycleDeleteReq = new CycleDeleteRequestDTO();
    		cycleDeleteReq.cycleId = cycleDTO.cycleId;
    		cycleDeleteReq.version = cycleDTO.version;
    		return cycleDeleteReq;
    	}

        //map services to return
        return {
        	getFormattedCycleSearchDTO : GetFormattedCycleSearchDTO,
        	getCycleSearchDTO : GetCycleSearchDTO,
        	getCycleDTO : GetCycleDTO,
        	getFormattedCycleSaveRequest: GetFormattedCycleSaveRequest,
        	getCycleSaveRequest : GetCycleSaveRequest,
        	getCycleDeleteRequestDTO : GetCycleDeleteRequestDTO,
        	getFormattedCycleDeleteRequestDTO : GetFormattedCycleDeleteRequestDTO
        }

    }
})();
